// export const BASE_URL = "https://test.api.erp.dynamicsoft.uz/api/";
export const BASE_URL = process.env.REACT_APP_BASE_URL;
